var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.2L11 6C11 5.71667 11.0959 5.47917 11.2875 5.2875C11.4792 5.09583 11.7167 5 12 5C12.2834 5 12.5209 5.09583 12.7125 5.2875C12.9042 5.47917 13 5.71667 13 6L13 14.2L15.9 11.3C16.0834 11.1167 16.3167 11.025 16.6 11.025C16.8834 11.025 17.1167 11.1167 17.3 11.3C17.4834 11.4833 17.575 11.7167 17.575 12C17.575 12.2833 17.4834 12.5167 17.3 12.7L12.7 17.3C12.5 17.5 12.2667 17.6 12 17.6C11.7334 17.6 11.5 17.5 11.3 17.3L6.70005 12.7C6.51672 12.5167 6.42505 12.2833 6.42505 12C6.42505 11.7167 6.51672 11.4833 6.70005 11.3C6.88338 11.1167 7.11672 11.025 7.40005 11.025C7.68338 11.025 7.91672 11.1167 8.10005 11.3L11 14.2Z",
    fill: "#DC272D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecArrow);
export default __webpack_public_path__ + "static/media/DecArrow.7d9b059a8202623697da360da8d12185.svg";
export { ForwardRef as ReactComponent };